import React from "react";
import { t } from "../i18n";

// Back button blended into the UI, styled like the navigation bar's profile
// button (pill shape). Placement is handled by the page (its header).
function BackArrow({ onClick, label }) {
  return (
    <button type="button" class="btn-primary back-btn" onClick={onClick}>
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
        <path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>{label || t("common.back")}</span>
    </button>
  );
}

export default BackArrow;
